import { IPromise } from 'angular';
import { IDjangoPackage } from '../../tn.common';
import DjangoClient, { IPagedResult } from '../../tn.django/django-client.service/djangoClient';

export class PackageRepository {
    static $inject = ['djangoClient'];
    constructor(protected djangoClient: DjangoClient) {}
    list(): IPromise<IPagedResult<IDjangoPackage>> {
        return this.djangoClient.getPaged<IDjangoPackage>('/api/1/packages/');
    }
    get(id: number): IPromise<IDjangoPackage> {
        return this.djangoClient.get<IDjangoPackage>('/api/1/packages/' + id);
    }
}
